export const formatValue = (val: number | null | undefined, unit = '', forceDecimals = false): string => {
  if (val === null || val === undefined || isNaN(val)) {
    return `0${unit ? ' ' + unit : ''}`;
  }
  
  const num = val || 0;
  const options: Intl.NumberFormatOptions = {
    minimumFractionDigits: (Math.abs(num) > 100 && !forceDecimals) ? 0 : 2,
    maximumFractionDigits: (Math.abs(num) > 100 && !forceDecimals) ? 0 : 2,
  };
  
  const formattedUnit = unit ? ` ${unit}` : '';
  return num.toLocaleString('de-DE', options) + formattedUnit;
};

export const formatCurrency = (val: number | null | undefined): string => {
  return formatValue(val, '€');
};

export const formatPercent = (val: number | null | undefined): string => {
  return formatValue(val, '%', true);
};

export const formatSquareMeter = (val: number | null | undefined): string => {
  return formatValue(val, 'm²');
};

export const formatSquareMeterPrice = (val: number | null | undefined): string => {
  return formatValue(val, '€/m²', true);
};

export const numberToWords = (num: number): string => {
  if (num === 0) return 'Null';
  
  const ones = ['', 'Ein', 'Zwei', 'Drei', 'Vier', 'Fünf', 'Sechs', 'Sieben', 'Acht', 'Neun'];
  const tens = ['', '', 'Zwanzig', 'Dreißig', 'Vierzig', 'Fünfzig', 'Sechzig', 'Siebzig', 'Achtzig', 'Neunzig'];
  const teens = ['Zehn', 'Elf', 'Zwölf', 'Dreizehn', 'Vierzehn', 'Fünfzehn', 'Sechzehn', 'Siebzehn', 'Achtzehn', 'Neunzehn'];
  
  const convertHundreds = (n: number): string => {
    let str = '';
    
    const hundreds = Math.floor(n / 100);
    const remainder = n % 100;
    
    if (hundreds > 0) {
      str += ones[hundreds] + 'hundert';
    }
    
    if (remainder >= 20) {
      const onesDigit = remainder % 10;
      const tensDigit = Math.floor(remainder / 10);
      if (onesDigit > 0) {
        str += ones[onesDigit] + 'und';
      }
      str += tens[tensDigit].toLowerCase();
    } else if (remainder >= 10) {
      str += teens[remainder - 10];
    } else if (remainder > 0) {
      str += ones[remainder];
    }
    
    return str;
  };
  
  const convertThousands = (n: number): string => {
    if (n >= 1000000) {
      const millions = Math.floor(n / 1000000);
      const remainder = n % 1000000;
      let result = convertHundreds(millions) + ' Million' + (millions > 1 ? 'en' : '');
      if (remainder > 0) {
        result += ' ' + convertThousands(remainder);
      }
      return result;
    } else if (n >= 1000) {
      const thousands = Math.floor(n / 1000);
      const remainder = n % 1000;
      let result = convertHundreds(thousands) + 'tausend';
      if (remainder > 0) {
        result += convertHundreds(remainder);
      }
      return result;
    } else {
      return convertHundreds(n);
    }
  };
  
  return convertThousands(Math.abs(num)) + ' Euro';
};

export const generateUUID = (): string => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : ((r & 0x3) | 0x8);
    return v.toString(16);
  });
};